'use client';

import type { GamificationMissionGroups, MissionsGroupVariants } from '../../types';
import { MissionsGroup } from '../MissionsGroup';

// INFO: In future we will have also fast missions
const missionGroupOrder: MissionsGroupVariants[] = ['welcome', 'daily', 'weekly'];

interface GamificationMissionsContentProps {
  loading: boolean;
  missionGroups: GamificationMissionGroups;
  onExpired: VoidFunction;
}

export const GamificationMissionsContent = ({ loading, missionGroups, onExpired }: GamificationMissionsContentProps) => {
  return (
    <>
      {/* TODO: will be opened when this logic will be ready. Do not remove this comment */}
      {/* {
        loading && (
          <div className="mt-5">
            <GmDailyStreakSkeleton />
          </div>
        )
      } */}
      {missionGroupOrder.map(variant => (
        <MissionsGroup
          key={variant}
          variant={variant}
          loading={loading}
          missions={missionGroups[variant].items}
          nextUpdate={missionGroups[variant].nextUpdate}
          onExpired={onExpired}
        />
      ))}
    </>
  );
};
